import { createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { localeSelector } from 'viewModel/selectors/locale/localeSelector';
import { PAYPAL_LEGAL_LINKS } from 'constants/PayPal';
import PaymentEN from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_en_US';
import PaymentFR from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentEN, PaymentFR);

const getPaypalLegalLocaleKey = ({ isCanada, isFRCanada }) => {
    if (!isCanada) {
        return 'us';
    }

    return isFRCanada ? 'caFr' : 'caEn';
};

const paypalLegalNoticeSelector = createSelector(localeSelector, () => {
    const isCanada = LanguageLocaleUtils.isCanada();
    const isFRCanada = LanguageLocaleUtils.isFRCanada();
    const localeKey = getPaypalLegalLocaleKey({ isCanada, isFRCanada });
    // For fr_CA we read a hardcoded key that has no _en_US.js counterpart so the SDL translation bot cannot overwrite the legally-reviewed copy.
    const resourceKey = isFRCanada ? 'paypalLegalNoticeHardcoded' : 'paypalLegalNotice';

    return getText(resourceKey, [PAYPAL_LEGAL_LINKS.terms[localeKey], PAYPAL_LEGAL_LINKS.privacy[localeKey]]);
});

export default paypalLegalNoticeSelector;
